/**
 * Defines the severity levels for module events.
 * Used to categorize events by their importance and impact.
 * Matches the TelemetryLevel enum sequence for consistency.
 */
export var ModuleEventLevel;
(function (ModuleEventLevel) {
    /** Debug events that provide detailed internal information for troubleshooting */
    ModuleEventLevel[ModuleEventLevel["Debug"] = 0] = "Debug";
    /** Information events that provide general operational details */
    ModuleEventLevel[ModuleEventLevel["Information"] = 1] = "Information";
    /** Warning events that indicate potential issues but don't prevent operation */
    ModuleEventLevel[ModuleEventLevel["Warning"] = 2] = "Warning";
    /** Error events that indicate failures or critical issues */
    ModuleEventLevel[ModuleEventLevel["Error"] = 3] = "Error";
    /** Critical events that indicate severe failures */
    ModuleEventLevel[ModuleEventLevel["Critical"] = 4] = "Critical";
})(ModuleEventLevel || (ModuleEventLevel = {}));
export default ModuleEventLevel;
//# sourceMappingURL=module-event-level.js.map